module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.2aea161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/fullscreen-image_hero_768.png
// module id = FOex
// module chunks = 0